export const Should_Cost_Url_Constant = {
  //We will use items below
  home: '/cost-modelling/should-cost-library',
  view: '/cost-modelling/should-cost-library/view-model',
  create: '/cost-modelling/should-cost-library/create-model',
  edit: '/cost-modelling/should-cost-library/edit-model',

  //old path variables
  Should_Cost_Library_View: '/cost-modelling/should-cost-library/view-should-cost-model',
  SKU_Management_Create: '/sku-management/create-new-model',
  SKU_Management_View: '/sku-management/view-should-cost',
  Should_Cost_Builder: '/should-cost-modeling/should-cost-builder',
}

export const Should_Cost_Workbench_Url_Constant = {
  home: '/cost-modelling/sku-should-cost-mapping',
  view: '/cost-modelling/sku-should-cost-mapping/view-model',
}
